import Base from "./Base"
import Local from "./Local"

const config = {
  ...Local,
  clientDevice: true,

  auth: Local.auth ? { ...Local.auth } : { ...Base.auth },
}

export default config
